// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2dqrx","title":"styles_title__1OniN","region":"styles_region__1V2NE"};